import React from 'react'

const Contact = ({text, icon}) => {
    return (
        <div className="flex items-center space-x-2">
            <span>{icon}</span>
            <span className="text-sm text-gray-600">{text}</span>
        </div>
    )
}

export default Contact
